import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import GlenIvyGuide from './pages/GlenIvyGuide'
import AllBrands from './pages/AllBrands'
import BlogList from './pages/BlogList'
import BlogArticle from './pages/BlogArticle'
import ProfilePage from './pages/ProfilePage'
import AdminNewsletter from './pages/AdminNewsletter'
import AdminAffiliateSyncs from './pages/AdminAffiliateSyncs'
import AdminAnalytics from './pages/AdminAnalytics'
import AdminAffiliateAnalytics from './pages/AdminAffiliateAnalytics'
import SubmitDeal from './pages/SubmitDeal'
import AdminModeration from './pages/AdminModeration'
import Header from './components/Header'
import Footer from './components/Footer'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/glen-ivy-guide" element={<GlenIvyGuide />} />
            <Route path="/all-brands" element={<AllBrands />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/affiliate-syncs" element={<AdminAffiliateSyncs />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/affiliate-analytics" element={<AdminAffiliateAnalytics />} />
          <Route path="/submit-deal" element={<SubmitDeal />} />
          <Route path="/admin/moderation" element={<AdminModeration />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
